import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const GraduateRolesRedirectPage: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (user) {
      // If already authenticated, go straight to the list
      navigate('/graduate-roles');
    } else {
      // If not authenticated, set flag and go to signup
      sessionStorage.setItem('onboardingRedirect', '/graduate-roles');
      navigate('/signup');
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <h2 className="text-xl font-semibold text-slate-900 mb-2">Redirecting...</h2>
      </div>
    </div>
  );
};

